module.exports = __webpack_public_path__ + "static/media/CheckedImage.99987dce.svg";